module.exports = __webpack_public_path__ + "img/share_txt_cb.94488cf4.png";